<template>
  <div class="card-page">
    <van-overlay :show="showShare" @click="showShare = false"><img src="../assets/images/share.png" alt="分享提示" class="share-img" /></van-overlay>
    <div v-if="skeleton" class="skeleton"><van-skeleton title :row="20" /></div>
    <main v-else class="card-content">
      <section class="card-hero">
        <header class="card-brand">
          <img :src="brandLogo" alt="海平创新" class="brand-logo" />
          <div>
            <strong>{{ form2.company || "深圳海平创新知识服务有限公司" }}</strong>
            <span>专注国际贸易合规与风险控制</span>
          </div>
        </header>
        <div class="identity-row">
          <div class="identity-copy">
            <h1>{{ form2.name || "个人名片" }}<img v-if="form2.openId" src="../assets/images/v.png" alt="已认证" class="verified-badge" /></h1>
            <p class="post">{{ form2.post || "专业顾问" }}</p><span class="orange-rule"></span><p class="company-name">{{ form2.company }}</p>
          </div>
          <img v-if="form2.headPic" :src="form2.headPic" :alt="form2.name" class="headshot" />
        </div>
        <div class="contact-list" aria-label="联系方式">
          <button type="button"><img src="../assets/images/card-contact-phone.png" alt="" class="contact-icon" /><span>{{ form2.mobile || "暂未提供电话" }}</span>
          <!-- @click="tel(form2.mobile)" -->
          <!-- <em>拨打</em> -->
          </button>
          <a :href="form2.email ? `mailto:${form2.email}` : undefined"><img src="../assets/images/card-contact-email.png" alt="" class="contact-icon" /><span>{{ form2.email || "暂未提供邮箱" }}</span>
            <!-- <em>邮件</em> -->
          </a>
          <button type="button" ><img src="../assets/images/card-contact-website.png" alt="" class="contact-icon" /><span>{{ form2.www || "暂未提供官网" }}</span>
            <!-- @click="browse(form2.www)" -->
            <!-- <em>访问</em> -->
          </button>
          <button type="button"><img src="../assets/images/card-contact-location.png" alt="" class="contact-icon" /><span>{{ form2.address || "暂未提供地址" }}</span>
            <!--  @click="address" -->
            <!-- <em>导航</em> -->
          </button>
        </div>
        <div v-if="form2.isShowCompanyRole && moreCompanys.length" class="more-roles"><span>更多职务</span><p v-for="(item, index) in moreCompanys" :key="index">{{ item.moreCompanyName }} · {{ item.moreCompanyRole }}</p></div>
        <div class="hero-actions">
          <button class="primary-action" type="button" @click="tel(form2.mobile)">预约咨询</button>
          <button class="qr-action" type="button" @click="qr_show(form2.wechatQrCode || form2.qrCodeUrl, 6)"><van-icon name="qr" /> 扫码联系</button>
        </div>
        <div class="hero-divider" aria-hidden="true"></div>
      </section>
      <!-- <section class="action-grid" aria-label="名片工具">
        <button type="button" @click="shareCard"><van-icon name="share-o" /><span>发送名片</span></button>
        <button type="button" @click="qr_show(form2.qrCodeUrl, 9, true)"><van-icon name="photo-o" /><span>图像名片</span></button>
        <button type="button" @click="qr_show(form2.wechatQrCode, 6)"><van-icon name="qr" /><span>立即加微信</span></button>
        <button v-if="form2.openId !== $cookies.get('openId')" type="button" @click="favorite"><van-icon :name="myFavoriteId ? 'star' : 'star-o'" /><span>{{ myFavoriteId ? "取消收藏" : "收藏名片" }}</span></button>
        <button type="button" @click="trailSys"><van-icon name="desktop-o" /><span>试用系统</span></button>
      </section> -->
      <van-swipe v-if="adverts.length && form2.isShowAd" 
                 class="ad-swipe" :autoplay="3000" indicator-color="#ef4f16">
        <van-swipe-item v-for="item in adverts" :key="item.id" @click="intoAd(item)">
          <img :src="item.faceUrl" :alt="item.title || '推荐内容'" />
        </van-swipe-item>
      </van-swipe>
      <section v-if="groupedCardEntries.length" class="card-entry-groups">
        <section v-for="group in groupedCardEntries" :key="group.key" class="entry-group">
          <header class="section-title"><h2>{{ group.title }}</h2><span></span></header>
          <article v-for="item in group.items" :key="item.id" class="entry-article"><h3 v-if="item.title && item.title !== group.title">{{ item.title }}</h3><div class="rich-content" v-html="item.content"></div></article>
        </section>
      </section>
    </main>
    <qrcode v-model="qrshow" :src="qrcode"></qrcode>
    <van-overlay :show="show" @click="show = false"><div class="image-card" @click.stop><img :src="qrcode" alt="名片二维码" /><img src="../assets/images/关闭.png" alt="关闭" class="close" @click="show = false" /></div></van-overlay>
  </div>
</template>

<script>
import mixin from "../utils/share";
import ladingPage from "../utils/ladingPage";
import qrcode from "@/components/qrcode";
import brandLogo from "../assets/images/logo-large.png";

export default {
  name: "Card",
  mixins: [mixin, ladingPage],
  data () {
    return { brandLogo, moreCompanys: [], myFavoriteId: null, showShare: false, qrshow: false, qrcode: "", form2: {}, show: false, adverts: [] };
  },
  computed: {
    groupedCardEntries () {
      const groups = { company: [], solution: [], personal: [] };
      (this.form2.cardEntryList || []).filter((item) => item && item.isH5Show).forEach((item) => {
        const title = String(item.title || "");
        if (/公司|企业|机构/.test(title)) groups.company.push(item);
        else if (/个人|创始人|专家|顾问/.test(title)) groups.personal.push(item);
        else groups.solution.push(item);
      });
      return [
        { key: "company", title: "公司介绍", items: groups.company },
        { key: "solution", title: "解决方案", items: groups.solution },
        { key: "personal", title: "个人介绍", items: groups.personal }
      ].filter((group) => group.items.length);
    }
  },
  created () {
    this.$api.get("/api/crm/businessCard/get", { id: this.$route.query.id }).then((res) => {
      this.form2 = res && res.result ? res.result : {};
      this.form.businessCard = this.form2;
      localStorage.setItem("tel", this.form2.mobile || "");
      localStorage.setItem("www", this.form2.www || "");
      localStorage.setItem("id", this.form.id || "");
      localStorage.setItem("businessCardId", this.form2.id || "");
      localStorage.setItem("address", `http://apis.map.qq.com/uri/v1/marker?marker=coord:${this.form2.lat || ""},${this.form2.lng || ""};title:${this.form2.company || ""};addr:${this.form2.address || ""}`);
      localStorage.setItem("productUrl", this.form2.productUrl || "");
      localStorage.setItem("openProduct", this.form2.openProduct || false);
      this.share();
      this.geet();
      if (this.form2.id) {
        this.getFavoriteStatus();
        this.getMoreCompanys();
        this.getAdverts();
      }
      this.$nextTick(() => { this.skeleton = false; });
      if (this.$route.query.share) this.shareCard();
    }).catch(() => {
      this.form2 = {};
      this.form.businessCard = {};
      this.$nextTick(() => { this.skeleton = false; });
    });
  },
  methods: {
    trailSys () { this.$router.push(`/trail?id=${localStorage.getItem("ladingPageId") || 0}&businessCardId=${this.form2.id || ""}&channelId=${localStorage.getItem("channelId") || 0}&formId=1301960739979264`); },
    intoAd (ad) { if (ad.ladingPage) window.location.href = ad.ladingPage; },
    getMoreCompanys () {
      if (!this.form2.moreCompanyName) return;
      const companies = this.form2.moreCompanyName.split(",");
      const roles = String(this.form2.moreCompanyRole || "").split(",");
      this.moreCompanys = companies.map((name, index) => ({ moreCompanyName: name, moreCompanyRole: roles[index] || "" }));
    },
    favorite () {
      if (this.myFavoriteId) {
        this.$api.post("/api/crm/businessCardFavorite/del", { id: this.myFavoriteId }).then((res) => {
          if (res.code === "C0000") { this.$toast({ message: "取消收藏成功", className: "_toast" }); this.getFavoriteStatus(); }
        });
        return;
      }
      this.$api.post("/api/crm/businessCardFavorite/add", { businessCardId: this.form2.id, companyId: this.form2.companyId, openId: this.$cookies.get("openId"), wechatUserId: null }).then((res) => {
        if (res.code === "C0000") { this.$toast({ message: "收藏成功", className: "_toast" }); this.getFavoriteStatus(); }
      });
    },
    getFavoriteStatus () {
      this.$api.post("/api/crm/businessCardFavorite/list", { data: { openId: this.$cookies.get("openId"), businessCardId: this.form2.id } }).then((res) => {
        if (res.code === "C0000") this.myFavoriteId = res.result && res.result.list && res.result.list.length ? res.result.list[0].id : null;
      });
    },
    getAdverts () {
      this.$api.post("/api/crm/ad/frontList", { data: { companyId: this.form2.companyId } }).then((res) => {
        if (res.code === "C0000" && res.result && res.result.list) this.adverts = res.result.list;
      });
    },
    browse (url) { if (url) window.location.href = url.indexOf("http") === -1 ? `http://${url}` : url; },
    qr_show (src, num, flag) {
      if (!src) return;
      this.qrcode = src;
      if (flag) this.show = true;
      else this.qrshow = true;
      this.Action(num);
    },
    shareCard (num) { if (num === 1) { this.$router.push("/cardDetails"); return; } this.showShare = true; },
    tel (value) { if (value) { window.location.href = `tel:${value}`; this.Action(8); } },
    address () { if (this.form2.address) window.open(`http://apis.map.qq.com/uri/v1/marker?marker=coord:${this.form2.lat || ""},${this.form2.lng || ""};title:${this.form2.company || ""};addr:${this.form2.address}`); }
  },
  components: { qrcode }
};
</script>

<style scoped lang="less">
@page-bg: #faf7f1; @surface: #fffdfc; @ink: #142033; @body: #333a45; @muted: #7f858d; @brand: #ef4f16; @gold: #d7a34a; @line: #e9e6e1;
button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
.card-page { min-height: 100vh; padding-bottom: 32px; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }
.card-content { max-width: 750px; margin: 0 auto; overflow: hidden; }
.card-hero { position: relative; padding: 37px 40px 0; overflow: hidden; background: @page-bg; }
.card-hero::after { position: absolute; top: 0; right: 0; bottom: 0; left: 0; background: url("../assets/images/card-hero-globe-bg.jpg") no-repeat; background-position: center center; background-size: cover; opacity: .86; content: ""; pointer-events: none; }
.card-brand, .identity-row, .contact-list, .more-roles, .hero-actions, .hero-divider { position: relative; z-index: 1; }
.card-brand { display: flex; align-items: center; min-height: 65px; }
.brand-logo { width: 65px; height: 65px; margin-right: 16px; object-fit: contain; }
.card-brand div { display: flex; flex: 1; flex-direction: column; min-width: 0; }
.card-brand strong { overflow: hidden; color: @ink; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; font-size: 30px; font-weight: 700; line-height: 1.3; text-overflow: ellipsis; white-space: nowrap; }
.card-brand span { margin-top: 5px; color: @muted; font-size: 20px; }
.identity-row { display: flex; align-items: flex-start; justify-content: space-between; min-height: 170px; margin-top: 58px; }
.identity-copy { min-width: 0; padding-top: 8px; }
.identity-copy h1 { display: flex; align-items: center; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 68px; font-weight: 800; line-height: 1; letter-spacing: 2px; }
.verified-badge { width: 36px; height: 36px; margin-left: 13px; object-fit: contain; }
.post { margin-top: 17px; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 33px; font-weight: 500; line-height: 1.2; }
.orange-rule { display: block; width: 42px; height: 4px; margin-top: 24px; border-radius: 2px; background: @brand; }
.company-name { max-width: 420px; margin-top: 21px; color: @body; font-size: 23px; line-height: 1.45; }
.headshot { flex: 0 0 auto; width: 166px; height: 166px; margin-left: 20px; border: 1px solid @gold; border-radius: 50%; object-fit: cover; background: @surface; }
.contact-list { margin-top: 35px; }
.contact-list button, .contact-list a { display: flex; align-items: center; width: 100%; min-height: 69px; color: @body; text-align: left; text-decoration: none; }
.contact-icon { flex: 0 0 auto; width: 42px; height: 42px; object-fit: contain; }
.contact-list span { min-width: 0; overflow: hidden; padding: 0 16px; font-size: 28px; text-overflow: ellipsis; white-space: nowrap; }
.contact-list em { margin-left: auto; color: @brand; font-size: 18px; font-style: normal; white-space: nowrap; }
.more-roles { padding: 20px 0 3px 53px; border-bottom: 1px solid @line; color: @muted; font-size: 24px; }
.more-roles p { margin-top: 10px; color: @body; font-size: 24px; line-height: 1.45; }
.hero-actions { display: flex; justify-content: flex-end; gap: 18px; margin-top: 34px; }
.primary-action, .qr-action { position: relative; display: inline-flex; box-sizing: border-box; align-items: center; justify-content: center; height: 46px; padding: 0 10px; border-radius: 12px; font-size: 19px; font-weight: 600; }
.primary-action::before, .qr-action::before { position: absolute; top: -21px; right: 0; bottom: -21px; left: 0; content: ""; }
.primary-action { width: 132px; color: #fff; background: @brand; box-shadow: 0 8px 16px rgba(239, 79, 22, .18); }
.qr-action { width: 146px; gap: 7px; border: 1px solid @brand; color: @brand; background: rgba(255, 253, 252, .82); }
.qr-action .van-icon { font-size: 22px; }
.hero-divider { width: 100%; height: 1px; margin-top: 24px; background: rgba(20, 32, 51, .14); }
.action-grid { display: grid; grid-template-columns: repeat(5, 1fr); min-height: 142px; padding: 16px 25px; border-top: 1px solid @line; border-bottom: 1px solid @line; background: @surface; }
.action-grid button { display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 0; color: @body; }
.action-grid .van-icon { color: @brand; font-size: 35px; }
.action-grid span { margin-top: 11px; font-size: 18px; white-space: nowrap; }
.ad-swipe { height: 240px; margin: 22px 40px 0; }
.ad-swipe img { display: block; width: 100%; height: 240px; object-fit: cover; }
.card-entry-groups { margin-top: 27px; padding: 0 40px 20px; background: @surface; }
.entry-group { padding: 36px 0 35px; border-bottom: 1px solid @line; }
.entry-group:last-child { border-bottom: 0; }
.section-title { display: flex; flex-direction: column; align-items: flex-start; }
.section-title h2 { color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 39px; font-weight: 800; line-height: 1.1; }
.section-title span { width: 38px; height: 5px; margin-top: 16px; border-radius: 3px; background: @brand; }
.entry-article + .entry-article { margin-top: 29px; padding-top: 29px; border-top: 1px solid @line; }
.entry-article h3 { margin-top: 25px; color: @ink; font-size: 28px; font-weight: 700; line-height: 1.45; }
.rich-content { margin-top: 24px; color: @body; font-size: 26px; line-height: 1.8; word-break: break-word; }
.rich-content /deep/ p { margin: 0 0 18px; }
.rich-content /deep/ img { display: block; max-width: 100% !important; height: auto !important; margin: 15px auto; }
.rich-content /deep/ table { display: block; max-width: 100%; overflow-x: auto; border-collapse: collapse; }
.rich-content /deep/ td { padding: 4px 8px; border-bottom: 1px solid @line; }
.share-img { display: block; width: 320px; height: 290px; margin: 20px 0 0 auto; }
.image-card { position: relative; width: 70%; margin: 60px auto 0; }
.image-card > img:first-child { display: block; width: 100%; height: auto; }
.image-card .close { position: absolute; bottom: -100px; left: 50%; width: 72px; height: 72px; transform: translateX(-50%); }
@media (max-width: 420px) {
  .card-page { padding-bottom: 20px; } .card-hero { padding: 25px 22px 0; }
  .brand-logo { width: 51px; height: 51px; margin-right: 11px; }
  .identity-row { min-height: 150px; margin-top: 44px; } .verified-badge { width: 28px; height: 28px; margin-left: 8px; } .headshot { width: 125px; height: 125px; margin-left: 12px; }
  .hero-actions { gap: 10px; margin-top: 25px; }
  .action-grid { min-height: 116px; padding: 10px 12px; } .action-grid .van-icon { font-size: 29px; } .action-grid span { margin-top: 7px; font-size: 14px; }
}
</style>
